import { Card, CardBody, CardFooter, Dialog } from "@material-tailwind/react";
import Label from "components/Label/Label";

import ButtonPrimary from "shared/Button/ButtonPrimary";

interface EntityDialogFormProps {
  open: boolean;
  handleClose?: () => void;
  handleDelete?: () => void;
  onSubmitSuccess?: () => void;
  details: { label: string; value: string | number | boolean }[];
  id?: any;
  value?: string;
  title?: string;
}

export const EntityDetails: React.FC<EntityDialogFormProps> = ({
  id,
  open,
  value,
  title,
  details,
  handleClose = () => {},
}) => {
  return (
    <>
      <Dialog size="xs" open={open} handler={handleClose} className="bg-transparent shadow-none">
        <div>
          <Card className="w-full max-w-5xl mx-auto">
            <CardBody className="flex flex-col gap-4">
              <div className="text-lg font-semibold text-center">{title}</div>
              <div className="w-full border-b border-neutral-400 dark:border-neutral-700"></div>

              <table className="w-full border-collapse">
                <tbody>
                  {details.map((detail, index) => (
                    <tr key={index}>
                      <td className="px-4 py-2 font-semibold text-gray-600">{detail.label}</td>
                      <td className="px-4 py-2">{detail.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
            <CardFooter className="flex justify-center ">
              <ButtonPrimary
                onClick={handleClose}
                className="bg-red-500 rounded-sm hover:bg-red-500"
                sizeClass="px-4 py-2   sm:px-6"
              >
                Quitter
              </ButtonPrimary>
            </CardFooter>
          </Card>
        </div>
      </Dialog>
    </>
  );
};
